import { render, staticRenderFns } from "./Paytable.vue?vue&type=template&id=1805251f&"
import script from "./Paytable.vue?vue&type=script&lang=js&"
export * from "./Paytable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports